module.exports = __webpack_public_path__ + "static/media/heart.3107cff2.svg";